import { __, compose, filter, keys, omit, startsWith } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePlaceTypesWithPermission } from '../../../../utils/helpers/placeTypes'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Picker from '../../../../components/form/Picker'

const TypePicker = () => {
  const { t } = useTranslation('editPlace')
  const types = usePlaceTypesWithPermission('create')
  const form = useForm()
  const { setForm } = useFormState()
  const handleChangeType = type => {
    const cleanForm = compose(
      omit(__, form), //
      filter(startsWith('placeLevel')),
      keys
    )(form)

    setForm({ ...cleanForm, type })
  }

  return (
    <FormItem
      label={t('type')}
      field="type"
      Input={Picker}
      onChange={handleChangeType}
      options={types.map(type => ({ value: type.key, label: type.name }))}
    />
  )
}
const GeneralSection = () => {
  const { initialState } = useModalData() || {}
  const shouldSelectType = !initialState?.type
  if (!shouldSelectType) return false

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" width_sm="100%">
        <TypePicker />
      </Col>
    </Grid>
  )
}

export default GeneralSection
